<template>
    <div>
        <ProblemModal  
            v-if="currentModal === 'problem'"
            :currentItem="currentOrder"
            :user="user"
            @close-modal="closeModal"
            @reportProblem="reportProblem"
            @refreshPacklist="refreshPacklist"
        />
        <MulticartModal
            v-if="currentModal === 'multicart'"
            @close-modal="closeModal"
            @confirm-multicart="confirmMulticart"
        />
        <DamagedModal
            v-if="currentModal === 'damaged'"
            @close-modal="closeModal"
            :article="currentArticleToReset"
        />
        <SettingsModal
            v-if="currentModal === 'settings'"
            :currentPrinter="currentPrinter"
            :openPrinterTab="openPrinterTab"
            :user="user"
            @close-modal="closeModal"
            @select-printer="selectPrinter"
            @reset-packlist="resetPacklist"
        />
        <MulticartConfirmModal
            v-if="currentModal === 'multicart-confirm'"
            @close-modal="closeModal"
            :packlistName="packlistName"
            :multicart-payload="multicartPayload"
            :current-packlist-items="currentPacklistItems"
            :current-order="currentOrder"
            :current-order-id="currentOrderId"
            @confirm-storage="confirmStorage"
        />
        <WarrantyModal
            v-if="currentModal === 'warranty'"
            :warranty-reason="warrantyReason"
            :warranty-note="warrantyNote"
            :current-order="currentOrder"
            @close-modal="closeModal"
        />
    </div>
</template>

<script>
import ProblemModal from '../modals/ProblemModal.vue';
import MulticartModal from '../modals/MulticartModal.vue';
import DamagedModal from '../modals/DamagedModal.vue';
import SettingsModal from '../modals/SettingsModal.vue';
import MulticartConfirmModal from '../modals/MulticartConfirmModal.vue';
import WarrantyModal from '../modals/WarrantyModal.vue';

export default {
    name: 'PacklistModals',
    components: {
        ProblemModal,
        MulticartModal,
        DamagedModal,
        SettingsModal,
        MulticartConfirmModal,
        WarrantyModal
    },
    props: {
        packlistName: {
            type: String,
            required: true
        },
        currentModal: {
            type: String,
            required: true
        },
        currentArticleToReset: {
            type: Object,
            required: true
        },
        currentPrinter: {
            type: Object,
            default: null
        },
        multicartPayload: {
            type: Object,
            default: null
        },
        currentPacklistItems: {
            type: Array,
            default: () => []
        },
        currentOrderId: {
            type: String,
            default: null
        },
        currentOrder: {
            type: Object,
            default: null
        },
        openPrinterTab: {
            type: Boolean,
            default: false
        },
        user: {
            type: Object,
            default: null
        },
        warrantyReason: {
            type: String,
            default: ''
        },
        warrantyNote: {
            type: String,
            default: ''
        }
    },
    methods: {
        closeModal() {
            this.$emit('close-modal');
        },
        selectPrinter(printer) {
            this.$emit('select-printer', printer);
        },
        confirmMulticart() {
            this.$emit('confirm-multicart');
        },
        confirmStorage(payload) {
            this.$emit('confirm-storage', payload);
        },
        reportProblem(message) {
            this.$emit('report-problem', message);
        },
        refreshPacklist() {
            this.$emit('refresh-packlist');
        },
        resetPacklist() {
            this.$emit('reset-packlist');
        }
    }
}
</script>